import { create } from "zustand";
import type { Room } from "./server/models/room";

interface Store {
  userId: string | null;
  setUserId: (userId: null | string) => void;
  room: null | Room;
  setRoom: (room: null | Room) => void;
}

export const useGameStore = create<Store>((set, get) => ({
  userId: null,
  setUserId: (userId) => set({ userId }),
  room: null,
  setRoom: (room) => set({ room }),
}));
